export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary-100 mb-6">
            <i className="ri-mail-send-line text-2xl text-primary-500" />
          </div>

          <h2 className="text-2xl md:text-3xl font-black text-foreground-900 mb-3">投稿爆料</h2>
          <p className="text-foreground-500 text-sm leading-relaxed mb-8 max-w-lg mx-auto">
            如果您掌握一手爆料线索或有独家黑料素材，欢迎通过以下方式联系我们。
            91黑料网始终致力于为读者呈现最真实、最新鲜的黑料视频内容，您的每一条线索都至关重要。
          </p>

          <div className="bg-background-100 rounded-2xl p-6 md:p-8 border border-background-200/60">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-lg text-accent-600" />
                </div>
                <div className="text-left">
                  <div className="text-xs text-foreground-400">爆料邮箱</div>
                  <div className="text-sm font-semibold text-foreground-800">tips@91heiliaowang.com</div>
                </div>
              </div>
              <div className="w-px h-10 bg-background-300/60 hidden sm:block" />
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-wechat-line text-lg text-primary-500" />
                </div>
                <div className="text-left">
                  <div className="text-xs text-foreground-400">微信客服</div>
                  <div className="text-sm font-semibold text-foreground-800">91heiliaowang</div>
                </div>
              </div>
              <div className="w-px h-10 bg-background-300/60 hidden sm:block" />
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-telegram-line text-lg text-secondary-600" />
                </div>
                <div className="text-left">
                  <div className="text-xs text-foreground-400">Telegram</div>
                  <div className="text-sm font-semibold text-foreground-800">@heiliaowang91</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}